/*
xrx-switch.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import React, { useEffect, useState } from 'react'

interface XrxSwitchProps {
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: (checked: boolean) => void
  label?: string
}

const XrxSwitch: React.FC<XrxSwitchProps> = ({ isChecked = false, isDisabled = false, onChange, label = '' }) => {
  const [checked, setChecked] = useState(isChecked)
  const [disabled, setDisabled] = useState(isDisabled)

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  useEffect(() => {
    setDisabled(isDisabled)
  }, [isDisabled])

  const handleToggle = () => {
    if (!disabled) {
      const newChecked = !checked
      setChecked(newChecked)
      if (onChange) {
        onChange(newChecked)
      }
    }
  }

  return (
    <div
      className={`xrx-switch ${disabled ? 'disabled' : ''}`}
      onClick={()=>handleToggle()}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
    >
       <input
          type="checkbox"
          className="xrx-switch-input"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => {
            // This ensures the onChange callback is called directly with the checkbox's value.
            const newChecked = e.target.checked
            setChecked(newChecked)
            if (onChange) {
              onChange(newChecked)
            }
          }}
        />
      <label className="xrx-switch-label">
        <div className="xrx-switch-background"></div>
        {label &&  <span className="xrx-switch-label-text">{label}</span>}
      </label>
    </div>
  )
}

export default XrxSwitch